// extracted by mini-css-extract-plugin
export default {"wrapper":"NoResultsFound_wrapper__wI0Fo","text":"NoResultsFound_text__DNRIq"};